import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_133_heads_balance_add_for_chart_of_accounts_head: ComponentConfig[] =
  [
    {
      componentType: LayoutTypes.SCREEN_GROUP,
      title: "Account flow",
      style: {
        backgroundColor: "#F9FAFB",
      },
      childComponents: [
        {
          componentType: LayoutTypes.GROUP,
          style: {
            backgroundColor: "#ffffff",
            direction: FlexDirection.COLUMN,
            borderRadius: 12,
            padding: 16,
          },
          childComponents: [
            {
              componentType: LayoutTypes.GROUP,
              Label: "",
              BindValue: "cont_Action",
              style: {
                direction: FlexDirection.ROW,
                padding: 0,
                margin: 0,
                marginBottom: 8,
              },
              childComponents: [],
            },
            {
              componentType: LayoutTypes.FORM,
              Name: "heads_balance_add_for_chart_of_accounts_head",
              TableName: "ledger_balances",
              DisplayName: "heads_balance_add_for_chart_of_accounts_head",
              columnNumber: "m1 t1 w3",
              style: {
                padding: 10,
                backgroundColor: "#ffffff",
                direction: FlexDirection.COLUMN,
              },
              childComponents: [
                {
                  componentType: ComponentType.SEARCHABLE_DROPDOWN,
                  name: "drp_ledger_id",
                  label: "Ledgers",
                  placeholder: "Select ledger",
                  required: true,
                  lookupName: "get_all_ledgers",
                  options: [],
                  disabled: true,
                  Json_Attribute: "ledger_id",
                  IncludeNotSet: true,
                  IsVerticalView: true,
                  validation: [
                    {
                      rule: ValidationRule.REQUIRED,
                      message: "Ledgers is required",
                    },
                  ],
                },
                {
                  componentType: ComponentType.SELECT_DROPDOWN,
                  name: "drp_fyear_id",
                  label: "Financial year",
                  placeholder: "Select financial year",
                  required: true,
                  lookupName: "get_current_accounting_year",
                  options: [],
                  Json_Attribute: "financial_year",
                  IncludeNotSet: true,
                  IsVerticalView: true,
                  validation: [
                    {
                      rule: ValidationRule.REQUIRED,
                      message: "Financial year is required",
                    },
                  ],
                },
                {
                  componentType: ComponentType.TEXT_FIELD,
                  name: "txt_opening_balance",
                  label: "Opening balance",
                  placeholder: "0.00",
                  required: false,
                  inputType: InputType.NUMBER,
                  defaultValue: "",
                  Json_Attribute: "opening_balance",
                  IsVerticalView: true,
                },
                {
                  componentType: ComponentType.TEXT_FIELD,
                  name: "txt_current_balance",
                  label: "Closing balance",
                  placeholder: "0.00",
                  required: false,
                  inputType: InputType.NUMBER,
                  defaultValue: "",
                  Json_Attribute: "current_balance",
                  IsVerticalView: true,
                  EnableEditForControl: true,
                },
                {
                  componentType: LayoutTypes.GROUP,
                  style: {
                    direction: FlexDirection.ROW,
                    padding: 16,
                    gap: 12,
                  },
                  childComponents: [
                    {
                      componentType: ComponentType.BUTTON,
                      name: "Submit",
                      Label: "Submit",
                      BindValue: "btn_submit",
                      onPressAction: "save",
                      ActionType: "Add",
                      ScreenId: "27",
                      style: {
                        backgroundColor: "var(--primary-green)",
                        textColor: "#FFFFFF",
                        padding: 12,
                        borderRadius: 6,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ];
